<template>
    <div style="width:100%; margin-left: 10px;">
		<el-row :gutter="10">
			<el-col :span="8">
				<el-autocomplete ref="searchAutocomplete" v-model="search_word" placeholder="輸入戶名、水號或表號查詢" size="small" class="search-field"
				@select="handleSelect" :fetch-suggestions="querySearch">
					<template slot-scope="{ item }">
						<div class="search-field-content">{{ item.value }}</div>
					</template>
					<template #append>
						<el-button icon="el-icon-search" @click="searchBtnClick()" size="small" :loading="searchBtnLoading" ></el-button>
					</template>
				</el-autocomplete>
			</el-col>
		</el-row>
		<el-divider > 				
			<el-switch v-model="type" active-text="流量計" active-value="流量計" active-color="#49c5ff" inactive-text="壓力計" inactive-value="壓力計" inactive-color="#49c5ff" @change="updateMap()" />
		</el-divider>
		<div v-loading="loading" element-loading-text="地圖載入中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" >
			<div style="width: 100%; height: 700px; border: 1px solid #C0C0C0"  ref="map-root" />
			<div ref="popup" class="box" >
				<div v-for="(item, key) in content" :key="key">
					<div v-if="item.waterId == target">
						<span @click.self="routerPush(item.waterId, item.waterNum, item.meterNum)" style="background-color: goldenrod;">{{ item.label }}</span> <br>
					</div>
					<div v-else>
						<span @click.self="routerPush(item.waterId, item.waterNum, item.meterNum)">{{ item.label }}</span> <br>
					</div>
				</div>
			</div>
			<div ref="statistic_1">
				<div v-show="show_1">
					<el-card class="card" shadow="hover">
						<div slot="header">
							<span>東區分處</span>
							<el-button style="color:black; float: left; padding: 3px 0" type="text" @click="show_1 = !show_1">{{show_1? "縮小" : "顯示"}}</el-button>
							<el-button style="color:black; float: right; padding: 3px 0" type="text" @click="closeCard('1')">關閉</el-button>
						</div>
						<el-table :data="tableData['1']" style="width: 100%" size="mini">
							<el-table-column prop="index" label="" />
							<!-- <el-table-column prop="leakage" label="洩漏" width="60" /> -->
							<el-table-column prop="lost" label="斷訊" width="60" />
							<el-table-column prop="normal" label="正常" width="60" />
						</el-table>
					</el-card>
				</div>
				<div v-show="! show_1">
					<el-card class="card" shadow="hover" style="width: 120px;">
						<div slot="header">
							<span>東區</span>
							<el-button style="color:black; float: left; padding: 3px 0" type="text" @click="show_1 = !show_1">{{show_1? "縮小" : "顯示"}}</el-button>
						</div>
					</el-card>
				</div>
			</div>
			<div ref="statistic_2">
				<div v-show="show_2">
					<el-card class="card" shadow="hover">
						<div slot="header">
							<span>西區分處</span>
							<el-button style="color:black; float: left; padding: 3px 0" type="text" @click="show_2 = !show_2">{{show_2? "縮小" : "顯示"}}</el-button>
							<el-button style="color:black; float: right; padding: 3px 0" type="text" @click="closeCard('2')">關閉</el-button>
						</div>
						<el-table :data="tableData['2']" style="width: 100%" size="mini">
							<el-table-column prop="index" label="" />
							<!-- <el-table-column prop="leakage" label="洩漏" width="60" /> -->
							<el-table-column prop="lost" label="斷訊" width="60" />
							<el-table-column prop="normal" label="正常" width="60" />
						</el-table>
					</el-card>
				</div>
				<div v-show="! show_2">
					<el-card class="card" shadow="hover" style="width: 120px;">
						<div slot="header">
							<span>西區</span>
							<el-button style="color:black; float: left; padding: 3px 0" type="text" @click="show_2 = !show_2">{{show_2? "縮小" : "顯示"}}</el-button>
						</div>
					</el-card>
				</div>
			</div>
			<div ref="statistic_3">
				<div v-show="show_3">
					<el-card class="card" shadow="hover">
						<div slot="header">
							<span>南區分處</span>
							<el-button style="color:black; float: left; padding: 3px 0" type="text" @click="show_3 = !show_3">{{show_3? "縮小" : "顯示"}}</el-button>
							<el-button style="color:black; float: right; padding: 3px 0" type="text" @click="closeCard('3')">關閉</el-button>
						</div>
						<el-table :data="tableData['3']" style="width: 100%" size="mini">
							<el-table-column prop="index" label="" />
							<!-- <el-table-column prop="leakage" label="洩漏" width="60" /> -->
							<el-table-column prop="lost" label="斷訊" width="60" />
							<el-table-column prop="normal" label="正常" width="60" />
						</el-table>
					</el-card>
				</div>
				<div v-show="! show_3">
					<el-card class="card" shadow="hover" style="width: 120px;">
						<div slot="header">
							<span>南區</span>
							<el-button style="color:black; float: left; padding: 3px 0" type="text" @click="show_3 = !show_3">{{show_3? "縮小" : "顯示"}}</el-button>
						</div>
					</el-card>
				</div>
			</div>
			<div ref="statistic_4">
				<div v-show="show_4">
					<el-card class="card" shadow="hover">
						<div slot="header">
							<span>北區分處</span>
							<el-button style="color:black; float: left; padding: 3px 0" type="text" @click="show_4 = !show_4">{{show_4? "縮小" : "顯示"}}</el-button>
							<el-button style="color:black; float: right; padding: 3px 0" type="text" @click="closeCard('4')">關閉</el-button>
						</div>
							<el-table :data="tableData['4']" style="width: 100%" size="mini">
								<el-table-column prop="index" label="" />
								<!-- <el-table-column prop="leakage" label="洩漏" width="60" /> -->
								<el-table-column prop="lost" label="斷訊" width="60" />
								<el-table-column prop="normal" label="正常" width="60" />
							</el-table>
					</el-card>
				</div>
				<div v-show="! show_4">
					<el-card class="card" shadow="hover" style="width: 120px;">
						<div slot="header">
							<span>北區</span>
							<el-button style="color:black; float: left; padding: 3px 0" type="text" @click="show_4 = !show_4">{{show_4? "縮小" : "顯示"}}</el-button>
						</div>
					</el-card>
				</div>
			</div>
			<div ref="statistic_5">
				<div v-show="show_5">
					<el-card class="card" shadow="hover">
						<div slot="header">
							<span>陽明分處</span>
							<el-button style="color:black; float: left; padding: 3px 0" type="text" @click="show_5 = !show_5">{{show_5? "縮小" : "顯示"}}</el-button>
							<el-button style="color:black; float: right; padding: 3px 0" type="text" @click="closeCard('5')">關閉</el-button>
						</div>
						<el-table :data="tableData['5']" style="width: 100%" size="mini">
							<el-table-column prop="index" label="" />
							<!-- <el-table-column prop="leakage" label="洩漏" width="60" /> -->
							<el-table-column prop="lost" label="斷訊" width="60" />
							<el-table-column prop="normal" label="正常" width="60" />
						</el-table>
					</el-card>
				</div>
				<div v-show="! show_5">
					<el-card class="card" shadow="hover" style="width: 120px;">
						<div slot="header">
							<span>陽明</span>
							<el-button style="color:black; float: left; padding: 3px 0" type="text" @click="show_5 = !show_5">{{show_5? "縮小" : "顯示"}}</el-button>
						</div>
					</el-card>
				</div>
			</div>
		</div>	
	</div>
</template>
  
<script>
import View from 'ol/View'
import Map from 'ol/Map'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import VectorImageLayer from 'ol/layer/VectorImage'
import { Cluster, OSM, Vector as VectorSource} from 'ol/source'
import Overlay from 'ol/Overlay'
import { Circle as CircleStyle, Fill, Stroke, Style, Text, Icon} from 'ol/style.js'
import { boundingExtent } from 'ol/extent.js'
import * as olProj from 'ol/proj'
import 'ol/ol.css'
import _ from 'lodash'
import Supercluster from 'supercluster'

export default {
	// tgosMap
	name: 'tgosMap',
	data() {
		return {
			show_1: screen.width >= 760 ? true : false,
			show_2: screen.width >= 760 ? true : false,
			show_3: screen.width >= 760 ? true : false,
			show_4: screen.width >= 760 ? true : false,
			show_5: screen.width >= 760 ? true : false,
			target: "",
			search_word: "",
			search_result: [],
			searchBtnLoading: false,
			points: [],
			labels: [],
			points_g: [],
			type: "流量計",
			loading: false,
			map: null,
			clusters: null,
			layer: null,
			statistic_1_overlay: null,
			statistic_2_overlay: null,
			statistic_3_overlay: null,
			statistic_4_overlay: null,
			statistic_5_overlay: null,
			tableData: {
				"1": [],
				"2": [],
				"3": [],
				"4": [],
				"5": [],
			},
			c: [],
			overlay: null,
			content: null,
			groups: null,
			_cluster: null,
			filename: "",
		}
	},
	computed:{
        currentUnitId()
        {
            return localStorage.getItem('unitId')
        }
    },
	beforeMount()
	{
		// window.onbeforeunload = function() {
		// 	return "Dude, are you sure you want to leave? Think of the kittens!";
		// }
	},
	async created()
	{
		// this._cluster = new Cluster({ distance: 60, minDistance: 10, source: new VectorSource()})
		this._cluster = new Supercluster({ radius: 50, maxZoom: 22})
	},
	async beforeDestroy()
	{
			this.search_word = ""
			this.points = []
			this.labels = []
			this.points_g = []
			this.type = "流量計"
			this.loading =  false
			this.map = null
			this.clusters = null
			this.layer = null
			this.statistic_1_overlay = null
			this.statistic_2_overlay = null
			this.statistic_3_overlay = null
			this.statistic_4_overlay = null
			this.statistic_5_overlay = null
			this.tableData = {
					"1": [],
					"2": [],
					"3": [],
					"4": [],
					"5": [],
				}
			this.c = []
			this.overlay = null
			this.content = null
			this.groups = null
			this._cluster = null
	},
	async mounted()
	{
		this.loading = true
		await this.getData()
		await this.getStatisticData()
		this.mapRender()
		this.loading = false
	},
	methods:
	{
		async updateMap()
		{
			await this.getData()
			this.handleNodeClick()
			if(this.type == "流量計")
			{
				this.map.addLayer(this.groups)
				this.map.addOverlay(this.statistic_1_overlay)
				this.map.addOverlay(this.statistic_2_overlay)
				this.map.addOverlay(this.statistic_3_overlay)
				this.map.addOverlay(this.statistic_4_overlay)
				this.map.addOverlay(this.statistic_5_overlay)
			}
			else
			{
				this.map.removeLayer(this.groups)
				this.map.removeOverlay(this.statistic_1_overlay)
				this.map.removeOverlay(this.statistic_2_overlay)
				this.map.removeOverlay(this.statistic_3_overlay)
				this.map.removeOverlay(this.statistic_4_overlay)
				this.map.removeOverlay(this.statistic_5_overlay)
			}
		},
		closeCard(unit)
		{
			if(unit === '1')
			{
				this.statistic_1_overlay.setPosition(undefined)
			}
			else if(unit === '2')
			{
				this.statistic_2_overlay.setPosition(undefined)
			}
			else if(unit === '3')
			{
				this.statistic_3_overlay.setPosition(undefined)
			}
			else if(unit === '4')
			{
				this.statistic_4_overlay.setPosition(undefined)
			}
			else if(unit === '5')
			{
				this.statistic_5_overlay.setPosition(undefined)
			}
		},
		mapRender()
		{
			// 多表用戶
			this.groups = new VectorLayer(
			{ 
				source: new VectorSource({ features: this.points_g }),
				style: (feature) =>
				{	
					// 設定點擊類型為group
					feature.set('myClickType', 'group')
					let style = new Style(
											{ 
												image: new Icon({ src: "https://amr.water.gov.taipei:8080/twdim/img/home_3.png" }),
												text: new Text({
															text: feature.get("label"),
															fill: new Fill({color: '#ff8033' }),
															stroke: new Stroke({ color: 'rgba(0, 0, 0, 0.8)', width: 4 }),
															offsetY: 15,
														})
											})
					return style
				}
			})

			this.clusters = new VectorLayer(
			{
				source: new VectorSource({}),
				style: (feature)  =>
				{
					let size = feature.get('point_count')
					let style = null
					if (size > 1)
					{
						// 設定點擊類型為cluster
						feature.set('myClickType', 'cluster')
						// cluster
						style = [
									// new Style(	{ 	image: new CircleStyle({ radius: 16+size*0.005, fill: new Fill({ color: 'rgba(255, 153, 102, 0.4)' }) }) }),
									new Style(	{
													image: new CircleStyle({  radius: _.min([14+size*0.008, 20]) ,  fill: new Fill({ color: 'rgba(255, 165, 0, 0.7)' }), }),
													text: new Text({
																	text: feature.get('point_count_abbreviated') + "",
																	fill: new Fill({color: '#fff' }),
																	stroke: new Stroke({ color: 'rgba(0, 0, 0, 0.6)', width: 3 }),
																}),
												}),
								]
					}
					else
					{
						// 設定點擊類型為single
						feature.set('myClickType', 'single')
						// single
						style = new Style({ 
											image: new CircleStyle({ radius: 7, fill: new Fill({ color: 'rgba(86, 86, 189, 0.7)' }) }),
											text: new Text({
															text: feature.get("label"),
															fill: new Fill({color: '#fff' }),
															stroke: new Stroke({ color: 'rgba(0, 0, 0, 0.8)', width: 4 }),
															offsetY: 15,
														}),
											})
					}
					return style
				},
			})
			
			this.overlay = new Overlay(	{  	element: this.$refs['popup'], 
											autoPan:{ animation: { duration: 250 }}
										})
			this.statistic_1_overlay = new Overlay(	{ element: this.$refs['statistic_1'], autoPan:{ animation: { duration: 250 }} })
			this.statistic_2_overlay = new Overlay(	{ element: this.$refs['statistic_2'], autoPan:{ animation: { duration: 250 }} })
			this.statistic_3_overlay = new Overlay(	{ element: this.$refs['statistic_3'], autoPan:{ animation: { duration: 250 }} })
			this.statistic_4_overlay = new Overlay(	{ element: this.$refs['statistic_4'], autoPan:{ animation: { duration: 250 }} })
			this.statistic_5_overlay = new Overlay(	{ element: this.$refs['statistic_5'], autoPan:{ animation: { duration: 250 }} })
			
			// 東區
			if(this.filename === "gps.json" || this.filename === "gps-1.json")
			{
				this.statistic_1_overlay.setPosition([121.65, 25.04])
				// this.statistic_1_overlay.setPositioning('center-left')
			}
			// 西區
			if(this.filename === "gps.json" || this.filename === "gps-2.json")
			{
				this.statistic_2_overlay.setPosition([121.28, 24.97])
				// this.statistic_2_overlay.setPositioning('top-right')
			}
			// 南區
			if(this.filename === "gps.json" || this.filename === "gps-3.json")
			{
				this.statistic_3_overlay.setPosition([121.65, 24.96])
				// this.statistic_3_overlay.setPositioning('top-left')
			}
			// 北區
			if(this.filename === "gps.json" || this.filename === "gps-4.json")
			{
				this.statistic_4_overlay.setPosition([121.28, 25.06])
				// this.statistic_4_overlay.setPositioning('center-right')
			}
			// 陽明
			if(this.filename === "gps.json" || this.filename === "gps-5.json")
			{
				this.statistic_5_overlay.setPosition([121.65, 25.12])
				// this.statistic_5_overlay.setPositioning('bottom-left')
			}


			this.map = new Map({
				target: this.$refs['map-root'],
				layers: [ new TileLayer({ source: new OSM()}), this.clusters, this.groups],
				overlays: [ this.overlay, this.statistic_1_overlay, this.statistic_2_overlay, this.statistic_3_overlay, this.statistic_4_overlay, this.statistic_5_overlay],
				view: new View({ zoom: 12, projection: 'EPSG:4326', center: [121.54, 25.01] /* 台北中心點 */, }),
			})

			this.map.getView().on('change:resolution', () =>
			{
				// this.statistic_1_overlay.setPosition(undefined)
				// this.statistic_2_overlay.setPosition(undefined)
				// this.statistic_3_overlay.setPosition(undefined)
				// this.statistic_4_overlay.setPosition(undefined)
				// this.statistic_5_overlay.setPosition(undefined)
			})

			this.map.on('moveend', this.handleNodeClick)

			this.map.on( 'click', async(e) =>
			{
				// 點擊物件是否為group
				let isGroup = false
				await this.groups.getFeatures(e.pixel).then( clickedFeatures =>
				{
					if(! _.isEmpty(clickedFeatures))
					{
						if(clickedFeatures[0].get('myClickType') === 'group')
						{
							isGroup = true
							if(this.map.getView().getZoom() < 18)
							{
								let extent = boundingExtent( clickedFeatures.map((r) => r.getGeometry().getCoordinates()) )
								this.map.getView().fit(extent, {duration: 1000, padding: [50, 50, 50, 50], size: this.map.getSize(), maxZoom: 18})
							}
							else
							{
								// 轉導到社區用水頁面
								this.groupRouterPush(clickedFeatures[0].get('groupId'), clickedFeatures[0].get('groupName'))
							}
						}
						
					}
				})

				// 若為group則不繼續
				if(isGroup)
				{
					return
				}

				this.clusters.getFeatures(e.pixel).then( clickedFeatures =>
				{
					if ( clickedFeatures )
					{
						if(! _.isEmpty(clickedFeatures))
						{
							// let myClickType = clickedFeatures[0].get('myClickType')
							// // 若類型為group則不繼續
							// if(myClickType && myClickType == 'group') {
							// 	return 
							// }

							// 點擊marker
							let feature = clickedFeatures[0]
							if (feature.get('point_count') > 1)
							{
								if(this.map.getView().getZoom() < 18)
								{
									this.map.getView().fit(
											_.map(feature.values_.geometry.extent_, (e) => { return _.round(e, 4)}),
											{duration: 1000, maxZoom: this.map.getView().getZoom()+3}
										)
								}
								else
								{
									this.content = []
									_.forEach(this._cluster.getLeaves(feature.get("cluster_id"), Infinity), i =>
									{
										this.content.push({
												label: i["label"],
												waterId: i["waterId"],
												waterNum: i["waterNum"],
												meterNum: i["meterNum"],
											})
									}) 
									this.overlay.setPosition(e.coordinate)
								}
							}
							else
							{
								// 點擊單座標
								this.routerPush(feature.get("waterId"), feature.get("waterNum"), feature.get("meterNum"))
							}	
						}
						else
						{
							this.overlay.setPosition(undefined)
						}
					}
				})
			})

		},
		async getStatisticData()
		{
			this.tableData = 
			{
				"1": [],
				"2": [],
				"3": [],
				"4": [],
				"5": [], 
			}
			let arr = ["1", "2", "3", "4", "5"]
			let r = {
					index: "社區 用水情形",
					leakage: 0,
					lost: 0,
					normal: 0,
				}
			let url = "/api/report/waterStatistics/community"
			await this.axios.get(url).then( res =>
			{	
				res = res.data
				_.forEach(arr, e => 
				{
					if(_.has(res, e))
					{
						this.tableData[e].push(
							{
								index: "社區 用水情形",
								lost: res[e]["lost"],
								normal: res[e]["normal"],
							}
						)
					}
					else
					{
						this.tableData[e].push(r)
					}
				})
			})
			
			// url = "/api/report/waterStatistics/general"
			// r = {
			// 		index: "一般 水質狀況",
			// 		leakage: 0,
			// 		lost: 0,
			// 		normal: 0,
			// 	}
			// await this.axios.get(url).then( res =>
			// {
			// 	res = res.data
			// 	_.forEach(arr, e => 
			// 	{
			// 		if(_.has(res, e))
			// 		{
			// 			this.tableData[e].push(
			// 				{
			// 					index: "一般 水質狀況",
			// 					leakage: res[e]["leakage"],
			// 					lost: res[e]["lost"],
			// 					normal: res[e]["normal"],
			// 				}
			// 			)
			// 		}
			// 		else
			// 		{
			// 			this.tableData[e].push(r)
			// 		}
			// 	})
			// })

			url = "/api/report/waterStatistics/general"
			r = {
					index: "一般 用水情形",
					leakage: 0,
					lost: 0,
					normal: 0,
				}
			await this.axios.get(url).then( res =>
			{
				res = res.data
				_.forEach(arr, e => 
				{
					if(_.has(res, e))
					{
						this.tableData[e].push(
							{
								index: "一般 用水情形",
								lost: res[e]["lost"],
								normal: res[e]["normal"],
							}
						)
					}
					else
					{
						this.tableData[e].push(r)
					}
				})
			})
		},
		async getData()
		{
			let url = ""
			if(this.type === "壓力計")
			{
				this.loading = true
				url = "/api/system/monitor?size=9999"
				await this.axios.get(url).then( res =>
				{
					if(_.isArray(res.data.content))
					{
						this.points = []
						let _points = []
						this.labels = []
						_.forEach( res.data.content, (e, index) =>
						{
							// supercluster
							_points.push({
								"geometry":
									{
										"type": "Point",
										"coordinates": [e.lng, e.lat]
									},
								"label":  e.waterNum + " - " + e.waterNum,
								"waterId": e.waterId,
								"waterNum": e.waterNum,
							})
							this.points[index] = new Feature(new Point( [e.lng, e.lat]))
							this.points[index].set("label", e.waterNum + " - [" + e.waterName + "] - " + e.waterNum)
							this.points[index].set("waterId", e.waterId)
							this.points[index].set("waterNum", e.waterNum)
							this.labels.push( {value: e.waterNum + " - " + e.waterNum, idValue: e.waterId })
						})
						this._cluster.load(_points)
					}
					else
					{
						this.$message({ message: '無法擷取資料!', type: 'warning' }) 
					}
				})
				.catch( () =>
				{
					this.$message({ message: '無法擷取資料!', type: 'warning' })
				})
				.finally( () =>
				{
					this.loading = false
				})
			}
			else if(this.type === "流量計")
			{
				url = "https://webpms-watertaipei.cdn.hinet.net/"
				await this.axios.get("/api/system/profile/gps/filename").then( res =>
				{
					this.filename = res.data
					// url += res.data	+ "?token=MjrBoKdc8EdBXmWy_KR8Vw"
				})
				await this.axios.get("/api/cdn/gen-url/" + this.filename).then( res =>
				{
					url = res.data
				})

				// this.filename = "gps.json"
				// url="https://webpms-watertaipei.cdn.hinet.net/gps2.json?token=MjrBoKdc8EdBXmWy_KR8Vw"
				await this.axios.get(url).then( res =>
				{
					if(_.isArray(res.data))
					{
						this.points = []
						let _points = []
						this.labels = []
						_.forEach( res.data, (e, index) =>
						{
							// supercluster
							_points.push({
								"geometry":
									{
										"type": "Point",
										"coordinates": [e.lng, e.lat]
									},
								"label":  e.waterNum + " - [" + e.waterName + "] - " + e.meterNum,
								"waterId": e.waterId,
								"waterNum": e.waterNum,
								"meterNum": e.meterNum,
							})

							this.points[index] = new Feature(new Point( [e.lng, e.lat]))
							this.points[index].set("label", e.waterNum + " - [" + e.waterName + "] - " + e.meterNum)
							this.points[index].set("waterId", e.waterId)
							this.points[index].set("waterNum", e.waterNum)
							this.points[index].set("meterNum", e.meterNum)
							this.labels.push( {value: e.waterNum + " - [" + e.waterName + "] - " + e.meterNum, idValue: e.waterId })
						})
						this._cluster.load(_points)
					}
					else
					{
						this.$message({ message: '無法擷取資料!', type: 'warning' }) 
					}
				})
				.catch( () =>
				{
					this.$message({ message: '無法擷取資料!', type: 'warning' })
				})
				.finally( () =>
				{
					this.loading = false
				})

				// 群組用戶
				url = "/api/system/profileGroup/gps"
				await this.axios.get(url).then( res =>
				{
					if(_.isArray(res.data))
					{
						this.points_g = []
						_.forEach( res.data, (e, index) =>
						{
							this.points_g[index] = new Feature(new Point( [e.lng, e.lat]))
							this.points_g[index].set("label", e.waterNum + " - [" + e.waterName + "] - " + e.meterNum)
							this.points_g[index].set("waterId", e.waterId)
							this.points_g[index].set("waterNum", e.waterNum)
							this.points_g[index].set("meterNum", e.meterNum)
							this.points_g[index].set("groupId", e.id)
							this.points_g[index].set("groupName", e.name)
						})
					}
					else
					{
						throw false
					}
				})
				.catch( () =>
				{
					this.$message({ message: '無法擷取資料!', type: 'warning' })
				})
				.finally( () =>
				{
					this.loading = false
				})

			}
		},
		routerPush(waterId, waterNum, meterNum)
		{
			let currentProfile = {
						waterId: waterId,
						waterNum: waterNum,
						meterNum: meterNum
					}
			localStorage.setItem('currentProfile', JSON.stringify(currentProfile))
			this.$router.push('/profile')
		},
		handleNodeClick()
		{
			let features = []
			_.forEach(this._cluster.getClusters(this.map.getView().calculateExtent((this.map.getSize())), this.map.getView().getZoom()), (e) =>
			{
				let feature = new Feature(new Point(e.geometry.coordinates))
				if(! _.has(e['properties'], 'point_count'))
				{
					feature.set("label", e.label)
					feature.set("waterId", e.waterId)
					feature.set("waterNum", e.waterNum)
					feature.set("meterNum", e.meterNum)
				}
				feature.setProperties(e['properties'])
				features.push(feature)
			})
			this.map.getLayers().getArray()[1].getSource().clear()
			this.map.getLayers().getArray()[1].getSource().addFeatures(features)
		},
		async querySearch(queryString, cb)
		{
			cb(this.search_result)
			/*
			let r = []
			if(queryString.includes(" "))
			{
				return
			}
			await this.axios.get("/api/system/profile/gps?keywords=" + queryString).then( res =>
			{
				if(_.isArray(res.data))
				{
					_.forEach( res.data, (e) =>
					{
						r.push( { value: e.waterNum + " - [" + e.waterName + "] - " + e.meterNum })
					})
				}
				else
				{
					throw false
				}
			})
			.catch( () =>
			{
				this.$message({ message: '無法擷取資料!', type: 'warning' })
			})
			.finally( () =>
			{
				cb(r)
			})
			*/
		},
		async searchBtnClick() {
			this.$refs['searchAutocomplete'].focus()
			this.searchBtnLoading = true
			this.search_result = []
			const url = `/api/system/profile/gps?keywords=${this.search_word}&unitId=${this.currentUnitId}`
			await this.axios.get(url).then( res =>
			{
				if(_.isArray(res.data) && res.data.length > 0)
				{
					_.forEach( res.data, (e) =>
					{
						this.search_result.push( { value: e.waterNum + " - [" + e.waterName + "] - " + e.meterNum + " - " + e.waterId, idValue: e.waterId })
					})
				}
				else
				{
					this.$message({ message: '查無資料。', type: 'warning' })
				}
			})
			.catch( () =>
			{
				this.$message({ message: '無法擷取資料!', type: 'error' })
			})

			this.searchBtnLoading = false
		},
		handleSelect(item)
		{
			this.target = item.idValue
			let features = this.points[ this.labels.findIndex(e => e.idValue == item.idValue) ]
			let extent = boundingExtent( [features.getGeometry().getCoordinates()])
			this.map.getView().fit(extent, {duration: 1000, maxZoom: 20})
		},
		groupRouterPush(groupId, groupName)
		{
			let currentCommunitGroup =
			{
				groupId: groupId,
				groupName: groupName
			}
			localStorage.setItem('currentCommunitGroup', JSON.stringify(currentCommunitGroup))
			this.$router.push('/CommunityGroupList')
		},
	}
}
</script>

<style scoped>
.box {
	border:1px solid #cccccc;
	width: 350px;
	height: 400px;
	background-color:#FFFFFF;
	padding:5px;
	overflow:auto;
}

.card {
    width: 420px;
  }

@media all and (max-width: 768px) {
	.search-field {
		width: 350px;
	}
	.search-field-content {
		white-space: normal;
	}
}
@media all and (min-width: 769px) {
	.search-field {
		width: 500px;
	}
}
</style>